import baustein from "baustein";
import { setFeedOrder } from "web/redux/ducks/feed-filters";
import store from "web/redux/store";
import analytics from "web/script/analytics/analytics";

const ACTIONS = {
    newest: "SORT_BY_NEWEST",
    price_desc: "SORT_BY_HIGH_LOW",
    price_asc: "SORT_BY_LOW_HIGH",
    recommended: "SORT_BY_RECOMMENDED",
    best_sellers: "SORT_BY_BEST_SELLERS",
};

const SORT_DROPDOWN_SELECTOR = ".sort-feed-dropdown";

export default baustein.register("sort-dropdown", {
    setupEvents(add) {
        add("change", SORT_DROPDOWN_SELECTOR, this._onChange);
    },

    /**
     * Handler for the change event on the sort dropdown.
     * Announces the change to Redux
     */
    _onChange() {
        const value = this.el.querySelector("[data-dropdown]").value;

        this._updateDropdownLabel(value);

        // add analytics
        const action = ACTIONS[value];
        analytics.event("SORT_BY", action);

        store.dispatch(setFeedOrder(value));
    },

    /**
     * Updates the dropdown label text to match the selected value.
     *
     * @param {String}
     */
    _updateDropdownLabel(value) {
        let option = this.el.querySelector(`option[value="${value}"]`);

        const selectedLabelText = option.getAttribute("data-selected-label");

        this.el.querySelector(".selected-sort-by-option-label").textContent = selectedLabelText;
    },
});
